import service from './request';

export function recordPageView(pagePath: string) {
  return service.post('/api/front/page-view', { pagePath }).catch(() => {});
}
